import { render } from "./Authorized.vue?vue&type=template&id=015de070"
import script from "./Authorized.vue?vue&type=script&lang=ts"
export * from "./Authorized.vue?vue&type=script&lang=ts"
script.render = render

export default script